import type React from 'react';

const BADGE_RED = '#e81123';

export function formatUnreadChatCount(count: number): string {
  if (count > 99) return '99+';
  return String(Math.max(0, count));
}

type BadgeSize = {
  height: number;
  minWidth: number;
  fontSize: number;
  paddingX: number;
};

function resolveBadgeSize(label: string): BadgeSize {
  if (label === '99+') {
    return { height: 18, minWidth: 26, fontSize: 9, paddingX: 5 };
  }
  if (label.length >= 2) {
    return { height: 20, minWidth: 20, fontSize: 10, paddingX: 0 };
  }
  return { height: 18, minWidth: 18, fontSize: 11, paddingX: 0 };
}

export function getChatUnreadDotStyle(
  borderColor: string
): React.CSSProperties {
  return {
    position: 'absolute',
    top: '2px',
    right: '2px',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: BADGE_RED,
    border: `2px solid ${borderColor}`,
    boxSizing: 'border-box',
    pointerEvents: 'none',
    zIndex: 2,
  };
}

/** Teams-style count badge — red circle, centered label, top-right overlap. */
export function getChatUnreadCountBadgeStyle(
  borderColor: string,
  count: number
): React.CSSProperties {
  const label = formatUnreadChatCount(count);
  const { height, minWidth, fontSize, paddingX } = resolveBadgeSize(label);
  const isCircle = label.length === 1;

  return {
    position: 'absolute',
    top: '-3px',
    right: '-5px',
    width: isCircle ? `${height}px` : undefined,
    minWidth: `${minWidth}px`,
    height: `${height}px`,
    padding: `0 ${paddingX}px`,
    borderRadius: '999px',
    background: BADGE_RED,
    border: `2px solid ${borderColor}`,
    boxSizing: 'border-box',
    pointerEvents: 'none',
    zIndex: 2,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    fontSize: `${fontSize}px`,
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: label === '99+' ? '-0.2px' : '0',
    fontFamily: "Roboto, 'Segoe UI', system-ui, sans-serif",
    whiteSpace: 'nowrap',
    textAlign: 'center',
  };
}
